import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Testimonials from "./components/Testimonials";

// DA 07 03 2023 Took out <Testimonials /> for now until I get one

export default function App() {
  return (
    <main className="text-gray-400 bg-gray-900 body-font">
      <Navbar />
      <About />
      <Projects />
      <Skills />

      <Contact />
    </main>
  );
}



// WEBPACK FOOTER //
// ./src/App.js